import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { featureFlag } from 'feature-flags/server/featureFlag'
import type { FeatureFlag } from 'feature-flags/types'

interface AkamaiEndpointVariables extends FeatureFlag {
	variables: {
		crossSellings: boolean
		menu: boolean
		orchestrator: boolean
		pdp: boolean
		plp: boolean
		homes: boolean
	}
	enabled: boolean
}

export const getAkamaiFF = () => {
	const { variables } = featureFlag<AkamaiEndpointVariables>(
		featureFlagKeys.AkamaiEndpoints
	)

	return {
		...variables,
	}
}
